// Mock data pour le site Riviera Signature VTC
export const mockData = {
  company: {
    name: "Riviera Signature VTC",
    logo: "/images/logo.png",
    tagline: "Transport premium sur la Côte d'Azur",
    description: "Service de VTC haut de gamme offrant des trajets élégants et sereins entre Nice, Cannes, Monaco et les principales destinations régionales. Chaque déplacement bénéficie d'une prise en charge personnalisée, alliant ponctualité, discrétion et confort.",
    phone: "+33 7 49 77 73 71",
    email: "contact@rivierasignaturevtc.fr",
    coverage: "Nice, Cannes, Monaco et Côte d'Azur"
  },

  services: [
    {
      id: 0,
      title: "Transfert Privé",
      description: "Transport privé pour vos déplacements quotidiens sur la Côte d'Azur",
      icon: "👤",
      features: ["Trajets personnalisés", "Prise en charge à l'adresse souhaitée", "Ponctualité assurée", "Paiement flexible"]
    },
    {
      id: 1,
      title: "Transfert Aéroport",
      description: "Service de transfert vers l'aéroport Nice Côte d'Azur et tous les aéroports de la région",
      icon: "✈️",
      features: ["Suivi de vol en temps réel", "Accueil personnalisé", "Aide aux bagages", "Temps d'attente inclus"]
    },
    {
      id: 2,
      title: "Transfert Gare",
      description: "Liaisons confortables vers toutes les gares de la Côte d'Azur avec ponctualité garantie",
      icon: "🚅",
      features: ["Gare de Nice-Ville", "Gare de Cannes", "Gare de Monaco", "Suivi temps réel des trains"]
    },
    {
      id: 3,
      title: "Mise à Disposition",
      description: "Véhicule et chauffeur à votre disposition pour vos déplacements sur la Côte d'Azur",
      icon: "🕐",
      features: ["Chauffeur dédié", "Flexibilité totale", "Attente incluse", "Trajets multiples"]
    },
    {
      id: 4,
      title: "Transfert Événement",
      description: "Transport premium pour vos événements, mariages et soirées sur la Riviera",
      icon: "🍾",
      features: ["Véhicule immaculé", "Tenue de soirée chauffeur", "Discrétion garantie", "Horaires flexibles"]
    }
  ],

  vehicles: [
    {
      id: 1,
      name: "Citroën C4 Plus 2025",
      category: "Berline Hybride Premium",
      passengers: 4,
      luggage: 4,
      features: ["Habitacle spacieux et silencieux", "Isolation acoustique renforcée", "Suspensions Advanced Comfort", "Sièges Advanced Comfort (ultra confort)", "Motorisation hybride silencieuse en ville"],
      images: [
        "/images/vehicle1.png",
        "/images/vehicle2.png",
        "/images/vehicle3.png",
        "/images/vehicle4.png",
        "/images/vehicle5.png"
      ]
    }
  ],

  pricing: [
    {
      id: 1,
      service: "Aéroport Nice ↔ Nice",
      price: "À partir de 15€",
      duration: "20-30 min",
      description: "Tarif final calculé selon adresse réservée.",
      tollIncluded: true
    },
    {
      id: 2,
      service: "Aéroport Nice ↔ Cannes",
      price: "À partir de 65€",
      duration: "45-60 min", 
      description: "Tarif final calculé selon adresse réservée.",
      tollIncluded: true
    },
    {
      id: 3,
      service: "Aéroport Nice ↔ Antibes",
      price: "À partir de 50€",
      duration: "30–40 min",
      description: "Tarif final calculé selon adresse réservée.",
      tollIncluded: true
    },
    {
      id: 4,
      service: "Aéroport Nice ↔ Monaco",
      price: "À partir de 65€",
      duration: "45-55 min",
      description: "Tarif final calculé selon adresse réservée.",
      tollIncluded: true
    },
    {
      id: 5,
      service: "Nice ↔ Èze / Beaulieu",
      price: "À partir de 40€",
      duration: "25–30 min",
      description: "Tarif final calculé selon adresse réservée.",
      tollIncluded: true
    },
    {
      id: 6,
      service: "Nice ↔ Saint-Tropez",
      price: "À partir de 230€",
      duration: "2h15",
      description: "Tarif final calculé selon adresse réservée.",
      tollIncluded: true
    },
    {
      id: 7,
      service: "Mise à disposition 3h",
      price: "200€",
      duration: "3 heures",
      description: "Service complet avec 100 km inclus",
      tollIncluded: false
    },
    {
      id: 8,
      service: "Mise à disposition journée",
      price: "550€",
      duration: "8 heures",
      description: "Service complet avec 300 km inclus",
      tollIncluded: false
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Alexandra Dubois",
      role: "Entrepreneuse",
      content: "Service exceptionnel ! Le véhicule est d'un confort incomparable et le trajet Nice-Monaco s'est fait dans un silence total. Chauffeur très professionnel.",
      rating: 5
    },
    {
      id: 2,
      name: "Jean-Pierre Martin",
      role: "Consultant International",
      content: "Ponctualité parfaite pour mes transferts aéroport. Le véhicule est toujours impeccable et le service client irréprochable. Je recommande vivement.",
      rating: 5
    },
    {
      id: 3,
      name: "Sofia Rossi",
      role: "Organisatrice d'événements",
      content: "Nous utilisons Riviera Signature VTC pour tous nos événements VIP. Service haut de gamme et véhicule très confortable.",
      rating: 5
    }
  ],

  // Données pour le formulaire de réservation
  timeSlots: [
    "06:00", "06:30", "07:00", "07:30", "08:00", "08:30", "09:00", "09:30",
    "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30",
    "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
    "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00"
  ],

  serviceTypes: [
    "Transfert",
    "Transfert aéroport/gare", 
    "Mise à disposition",
    "Transfert événement"
  ]
};

// Prix facturé au kilometre 
export const PRICE_PER_KM = 2.1;
